import { axios } from '@/axios';
import routes from '@/web-api/routes';
import storageManager from '@/storage-manager';
import storeHelper from '@/vuex/helper'; //eslint-disable-line

export default {
  /**
   * Reirect Modal registration
   */
  registerUserWithoutPassword({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post(routes.webapi.user.registerWithoutPassword, payload)
        .then((response) => {
          commit('setUserData', response.data.data.user);
          resolve(response);
        })
        .catch((error) => {
          return reject(error.response);
        });
    });
  },

  /**
   * Consolidated Route for all registration
   */
  registerUserWithPassword({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post(routes.webapi.user.registerWithPassword, payload)
        .then((response) => {
          commit('setUserData', response.data.data.user);
          resolve(response);
        })
        .catch((error) => {
          return reject(error.response);
        });
    });
  },

  /**
   * Triggered only by incremental data forms.
   * Updates the existing user
   * @param {*} Store
   * @param payload - User object containing a mix of fields course, grad year...
   *
   * {
   *   jobs_subscription: 1,
   *   degree_discipline: ACC,
   * }
   *
   */
  updateUser({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.put(`${routes.webapi.user.update}`, payload)
        .then((response) => {
          commit('updateUserData', response.data.data.user);
          return resolve(response.data);
        })
        .catch((error) => {
          storeHelper.handleUnauthorised(error);
          return reject(error);
        });
    });
  },

  // /**
  //  * Re-authenticates a user based on session length
  //  * @param {*} Store
  //  * @param password - Users password they enter into re-authentication form
  //  *
  //  *
  //  */
  // reAuthenticateUser({ commit }, password) {
  //   return new Promise((resolve, reject) => {
  //     axios.post(`${routes.webapi.user.reAuthenticate}`, { password })
  //       .then((response) => {
  //         commit('updateUserData', response.data.data.user);
  //         return resolve(response.data);
  //       })
  //       .catch((error) => {
  //         storeHelper.handleUnauthorised(error);
  //         return reject(error);
  //       });
  //   });
  // },

  /**
   * Triggered only by login form
   * Updates the existing user
   * @param {*} Store
   * @param payload - User object containing email, password
   */
  logInUser({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post(routes.webapi.user.login, payload)
        .then((response) => {
          if (response.data.status === 200) {
            commit('setUserData', response.data.data.user);
            resolve(response);
          } else {
            // TODO: backend should return a non 200 response code
            // This should be fixed in the backend now so could potentially be removed
            reject(response);
          }
        })
        .catch((error) => {
          return reject(error.response);
        });
    });
  },

  /**
   * Triggered by clicking logout in incremental data header
   * On logout clear session storage of items, then submit form via ajax.
   * Updates the existing user
   */
  logOutUser({ commit }) {
    const $logoutForm = document.querySelector('.LogoutForm');

    storageManager.emptySessionStorage({ key: 'saved-items|items' });
    commit('resetData');
    $logoutForm.submit();
  },

  /**
   * Unsubscribe from all communications
   * Including Job alerts, company opt ins etc
   */
  unsubscribeAll({ commit }) {
    return new Promise((resolve, reject) => {
      axios.post(`${routes.webapi.user.unsubscribeAll}`)
        .then((response) => {
          commit('updateUserData', response.data.data.user);
          commit('savedItems/unsubscribeFromAllReminders', {}, { root: true });
          return resolve(response.data.data);
        })
        .catch((error) => {
          storeHelper.handleUnauthorised(error);
          return reject(error);
        });
    });
  },

  changeUserPassword({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`${routes.webapi.user.changePassword}`, payload)
        .then((response) => {
          commit('updateUserData', response.data.data.user);
          return resolve(response.data.data);
        })
        .catch((error) => {
          storeHelper.handleUnauthorised(error);
          return reject(error.response.data);
        });
    });
  },

  changeUserEmail({ commit }, email) {
    return new Promise((resolve, reject) => {
      axios.post(`${routes.webapi.user.changeEmail}`, { email })
        .then((response) => {
          commit('updateUserData', response.data.data.user);
          return resolve(response.data);
        })
        .catch((error) => {
          storeHelper.handleUnauthorised(error);
          return reject(error);
        });
    });
  },

  /**
   * Get My hub items for the User Dashboard including recommended jobs, companies and articles
   */
  getUserDashboardItems() {
    return new Promise((resolve, reject) => {
      axios.get(`${routes.webapi.user.dashboardItems}`)
        .then((response) => {
          return resolve(response.data.data);
        })
        .catch((error) => {
          storeHelper.handleUnauthorised(error);
          return reject(error);
        });
    });
  },

  getUserReviews() {
    return new Promise((resolve, reject) => {
      axios.get(`${routes.webapi.user.review}`)
        .then((response) => {
          return resolve(response.data.data.reviews);
        })
        .catch((error) => {
          storeHelper.handleUnauthorised(error);
          return reject(error);
        });
    });
  },
};
